let payPal1 = false;
let payPal2 = false;

export function wasPayPal1Invoked() {
    return payPal1;
}

export function setPayPal1Invoked(v) {
    payPal1 = v;
}

export function wasPayPal2Invoked() {
    return payPal2;
}

export function setPayPal2Invoked(v) {
    payPal2 = v;
}

export function reset() {
    payPal1 = false;
    payPal2 = false;
}